module.exports = __webpack_public_path__ + "media/fonts/OFN-v2-433dc0efedbd9e7b8e77ede5aa5a533d.ttf";